import { render } from "./ModalDesc.vue?vue&type=template&id=dc683e72&scoped=true"
import script from "./ModalDesc.vue?vue&type=script&lang=js"
export * from "./ModalDesc.vue?vue&type=script&lang=js"

import "./ModalDesc.vue?vue&type=style&index=0&id=dc683e72&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dc683e72"

export default script